// @ts-check
import './SmallAlarmList.scss';
import React, { useCallback, useMemo } from 'react';
import { useAlarmPushService } from '../../services/AlarmApi/AlarmApi';
import _ from 'lodash';
import SimpleTable from 'components/Common/SimpleTable/SimpleTable';
import AlarmIcon from './Icons/AlarmIcon';
import { Button, ButtonVariant } from '@patternfly/react-core';
import useAPI from 'services/useAPI';
import createMutationRequest from 'utils/createMutationRequest';
import { useMutation } from '@tanstack/react-query';
import { isoToRelativeOrAbsolute } from 'utils/time';
import { Icons } from 'components/Common';

/**
 * @param {string} assetId - The asset id
 * @returns {{ hasAlarms: boolean; SmallAlarmList: () => JSX.Element; }}
 */
const useSmallAlarmList = (assetId) => {
  const filterOptions = useMemo(() => ({ assetIds: [assetId] }), [assetId]);
  const [alarms, isLoading] = useAlarmPushService(filterOptions);
  const api = useAPI();
  const alarmAckQuery = useMutation({
    mutationFn: createMutationRequest(api.core.acknowledgeAlarmStatus),
    onSuccess: () => {
    }
  });

  const columns = useMemo(() => {
    return [
      {
        path: '.',
        label: '',
        render: (alarm) => {
          return (
            <AlarmIcon
              status={alarm.status}
              isAcknowledged={alarm.isAcknowledged}
            />
          );
        }
      },
      {
        path: 'timestamp',
        label: '',
        render: (timestamp) => {
          return isoToRelativeOrAbsolute(timestamp);
        }
      },
      {
        path: 'name',
        label: ''
      },
      {
        path: '.',
        label: '',
        render: (alarm) => {
          if (alarm.isAcknowledged === true) {
            return null;
          }
          return (
            <>
              <Button
                isLoading={alarmAckQuery.isLoading}
                onClick={() => alarmAckQuery.mutate(alarm.id)}
                variant={ButtonVariant.secondary}
                icon={<Icons.Checkmark />} />
            </>
          );

        }
      }

    ];
  }, [alarmAckQuery]);

  // const filteredAlarms = _.filter(alarms, alarm => (alarm.status === 'active' || alarm.isAcknowledged !== true));

  const filteredAlarms = useMemo(() => {
    const filtered = _.filter(alarms, alarm => (alarm.status === 'active' || alarm.isAcknowledged !== true));
    return filtered;
  }, [alarms]);

  const hasAlarms = !_.isEmpty(filteredAlarms);

  const SmallAlarmList = useCallback(() => {
    return (
      <SimpleTable
        isLoading={isLoading}
        columns={columns}
        data={filteredAlarms}
        compact
        emptyListText="No active alarms"
      />
    );
  }, [columns, filteredAlarms, isLoading]);

  return { SmallAlarmList, hasAlarms };
};

export default useSmallAlarmList;
